const RELOAD_FLAG = 'chunk-reload-attempted';

function isChunkLoadError(value: unknown): boolean {
  if (!value) return false;
  if (typeof value === 'object') {
    const err = value as { name?: unknown; message?: unknown };
    if (err.name === 'ChunkLoadError') return true;
    if (
      typeof err.message === 'string' &&
      /Loading chunk .* failed/i.test(err.message)
    ) {
      return true;
    }
  }
  if (typeof value === 'string' && /Loading chunk .* failed/i.test(value)) {
    return true;
  }
  return false;
}

function reloadOnce(): void {
  if (sessionStorage.getItem(RELOAD_FLAG)) return;
  sessionStorage.setItem(RELOAD_FLAG, '1');
  window.location.reload();
}

export function installChunkReloadHandler(): void {
  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event.error) || isChunkLoadError(event.message)) {
      reloadOnce();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadOnce();
    }
  });
}
